var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-navbar-nav',{staticClass:"nav"},[_c('b-nav-item',{attrs:{"id":"email","to":{
      name: 'apps-email',
    }}},[_c('feather-icon',{attrs:{"icon":"MailIcon","size":"21","badge":_vm.count,"badge-classes":"bg-danger"}}),_c('b-tooltip',{attrs:{"triggers":"hover","target":"email","title":"پیام ها","delay":{ show: 500, hide: 50 }}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }